<script lang="ts" setup>
import type { Galleries } from '~/types/MainPage';

defineProps<{ data: Galleries }>();
</script>

<template>
  <section class="tiles">
    <template v-if="data.title">
      <AppLink
        v-if="data.url"
        :to="makeUrlRelative(data.url)"
        class="w-fit"
      >
        <h2 class="inline underline underline-offset-4">
          {{ data.title }}
        </h2>
      </AppLink>

      <h3
        v-else
        class="inline"
      >
        {{ data.title }}
      </h3>
    </template>

    <div class="grid md:hidden grid-cols-1 sm:grid-cols-2 grid-rows-auto justify-items-center gap-2">
      <AppLink
        v-for="item in data.gallery_mobile"
        :key="item.url"
        :class="{ 'hover:opacity-80': item.url }"
        :to="makeUrlRelative(item.url)"
        class="relative transition-opacity rounded-xl overflow-hidden"
      >
        <picture>
          <source
            :srcset="item.thumb_webp.thumb_350"
            type="image/webp"
          />

          <source
            :srcset="item.thumb.thumb_350"
            type="image/jpeg"
          />

          <img
            :alt="item.alt"
            :src="item.thumb.thumb_350 || item.full"
          />
        </picture>

        <div class="tiles__text-over-image">
          <div
            v-if="item.text_over_image_small"
            class="font-bold"
          >
            {{ item.text_over_image_small }}
          </div>

          <div
            v-if="item.text_over_image_big"
            class="font-bold text-2xl leading-none"
          >
            {{ item.text_over_image_big }}
          </div>
        </div>
      </AppLink>
    </div>

    <div class="hidden md:grid grid-cols-4 grid-rows-auto gap-4">
      <AppLink
        v-for="item in data.gallery_desktop"
        :key="item.url"
        :class="{ 'hover:opacity-80': item.url }"
        :to="makeUrlRelative(item.url)"
        class="relative transition-opacity rounded-2xl overflow-hidden"
      >
        <picture>
          <source
            :srcset="item.thumb_webp.thumb_390"
            type="image/webp"
          />

          <source
            :srcset="item.thumb.thumb_390"
            type="image/jpeg"
          />

          <img
            :alt="item.alt"
            :src="item.thumb.thumb_390 || item.full"
          />
        </picture>

        <div class="tiles__text-over-image">
          <div
            v-if="item.text_over_image_small"
            class="font-bold"
          >
            {{ item.text_over_image_small }}
          </div>

          <div
            v-if="item.text_over_image_big"
            class="font-bold text-2xl leading-none"
          >
            {{ item.text_over_image_big }}
          </div>
        </div>
      </AppLink>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tiles {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__text-over-image {
    position: absolute;
    top: 50%;
    right: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-end;
    color: $white;
    transform: translateY(-50%);

    @include screen-md {
      gap: 8px;
    }
  }
}
</style>
